import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NewsFeedItemContentBase } from '../news-feed-item-content-base';

@Component({
    selector: 'fi-news-feed-item-content-document',
    templateUrl: './news-feed-item-content-document.component.html',
    styleUrls: ['./news-feed-item-content-document.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedItemContentDocumentComponent extends NewsFeedItemContentBase {}
